<template>
  <v-container fluid>
    <v-app-bar app>
      <v-btn icon to="/prealert">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon to="/prealert">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="pt-4 pb-4 pl-4 pr-4">
      <div class="">
        <div class="pb-0">
          <v-form v-model="valid">
            <h2 class="headline mb-3">
              {{ language.create }} {{ language.pre_alerts }}
            </h2>

            <v-text-field
              solo
              required
              :rules="required"
              v-model="text4"
              :label="language.tracking_no"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text5"
              :label="language.content"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text6"
              :label="language.invoice_value"
              type="text"
            ></v-text-field>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text7"
              :label="language.supplier"
              type="text"
            ></v-text-field>
          </v-form>
        </div>
        <div>
          <v-btn
            :disabled="!valid"
            block
            color="secondary"
            @click="validateLogin"
            >{{ language.save }}</v-btn
          >
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  data() {
    return {
      clipped: false,
      currentUser: undefined,
      noData: false,
      loading: false,
      valid: false,
      required: (v) => !!v || this.language.the_field_is_required,
      text4: null,
      text5: null,
      text6: null,
      text7: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    language: function() {
      return this.$store.getters.language;
    },
  },
  mounted() {
    console.log(Server);
    // if(this.currentUser != undefined){
    // }else

    if (this.user.userName != null) {
      this.currentUser = this.user;
    }
  },
  methods: {
    validateLogin: function() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text4txt", this.text4);
      formData.append("text5txt", this.text5);
      formData.append("text6txt", this.text6);
      formData.append("text7txt", this.text7);

      console.log(Server.createPrealerta);
      // Helpers.getJson(Server.createPrealerta, "POST", formData, json => {});
      Helpers.getJson(Server.createPrealerta, "POST", formData, () => {});
      this.$router.push("prealert");
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
